import requests from './httpService';

const BASE = '/rbac-admin';

const RbacAdminService = {
  // Roles
  listRoles() {
    return requests.get(`${BASE}/roles`);
  },
  createRole(body) {
    return requests.post(`${BASE}/roles`, body);
  },
  updateRole(code, body) {
    return requests.put(`${BASE}/roles/${code}`, body);
  },
  deleteRole(code) {
    return requests.delete(`${BASE}/roles/${code}`);
  },

  // Resources
  listResources() {
    return requests.get(`${BASE}/resources`);
  },
  createResource(body) {
    return requests.post(`${BASE}/resources`, body);
  },
  updateResource(code, body) {
    return requests.put(`${BASE}/resources/${code}`, body);
  },
  deleteResource(code) {
    return requests.delete(`${BASE}/resources/${code}`);
  },

  // Role permissions
  listRolePermissions(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return requests.get(`${BASE}/role-permissions${qs ? `?${qs}` : ''}`);
  },
  upsertRolePermission(body) {
    return requests.post(`${BASE}/role-permissions`, body);
  },
  bulkUpsertRolePermissions(items) {
    return requests.post(`${BASE}/role-permissions/bulk`, { items });
  },
  deleteRolePermission(id) {
    return requests.delete(`${BASE}/role-permissions/${id}`);
  },
  getMatrix(roleCode) {
    return requests.get(`${BASE}/matrix?roleCode=${encodeURIComponent(roleCode)}`);
  },

  // Screens
  listScreens() {
    return requests.get(`${BASE}/screens`);
  },
  createScreen(body) {
    return requests.post(`${BASE}/screens`, body);
  },
  updateScreen(id, body) {
    return requests.put(`${BASE}/screens/${id}`, body);
  },
  deleteScreen(id) {
    return requests.delete(`${BASE}/screens/${id}`);
  },

  // API endpoints
  listApiEndpoints(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return requests.get(`${BASE}/api-endpoints${qs ? `?${qs}` : ''}`);
  },
  createApiEndpoint(body) {
    return requests.post(`${BASE}/api-endpoints`, body);
  },
  updateApiEndpoint(id, body) {
    return requests.put(`${BASE}/api-endpoints/${id}`, body);
  },
  deleteApiEndpoint(id) {
    return requests.delete(`${BASE}/api-endpoints/${id}`);
  },

  // Seed
  runSeed() {
    return requests.post(`${BASE}/seed`, {});
  },
};

export default RbacAdminService;
